/**
 * ContractEstimateSlice Options Reducers
 * 
 * Reducers for managing available centers and payers.
 */

import { PayloadAction } from '@reduxjs/toolkit';
import { ContractEstimateSliceState } from '../state';
import { CenterOption, PayerOption } from '../../types/contractEstimateTypes';

/**
 * Set available centers for selection
 */
export const setAvailableCenters = (
  state: ContractEstimateSliceState,
  action: PayloadAction<CenterOption[]>
) => {
  state.availableCenters = action.payload;
};

/**
 * Set available payers for selection
 */
export const setAvailablePayers = (
  state: ContractEstimateSliceState,
  action: PayloadAction<PayerOption[]>
) => {
  state.availablePayers = action.payload;
};
